export default {
  stats: [],
  stats_errors: [],
  stats_loading: false,

};
